<script lang="ts">
  import { cx } from '@emotion/css';
  import { ResponsiveVars } from '@twist/core';
  import type { CustomBlockComponentProps } from '@portabletext/svelte';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import FontSizeDecorator from '../Decorators/FontSizeDecorator.svelte';

  export let portableText: CustomBlockComponentProps<{
    children: {
      marks: string[];
    }[];
    listItem: 'number' | 'bullet';
  }>;

  const responsiveVars = new ResponsiveVars()
    .addFluid('margin-bottom', toFluidVarInput(14, 16))
    .addFluid('font-size', toFluidVarInput(16, 16))
    .toCSS();
</script>

<li
  class={cx(responsiveVars)}
  class:dot={portableText.value.listItem === 'bullet'}
  class:number={portableText.value.listItem === 'number'}
>
  <FontSizeDecorator size="normal">
    <slot />
  </FontSizeDecorator>
</li>

<style lang="scss">
  @import 'src/scss/variables';

  li {
    display: list-item;
    font-size: var(--font-size);

    margin-bottom: var(--margin-bottom);

    &:last-of-type {
      margin-bottom: 0;
    }
  }
</style>
